export default __webpack_public_path__ + "static/media/ticket-outline.a96447f8.svg";